const CustomerActionTypes = {
  GET_CUSTOMERS: 'GET_CUSTOMERS',
  GET_CUSTOMERS_SUCCESS: 'GET_CUSTOMERS_SUCCESS',
  GET_CUSTOMERS_FAILED: 'GET_CUSTOMERS_FAILED',

  GET_CUSTOMER_DETAILS: 'GET_CUSTOMER_DETAILS',
  GET_CUSTOMER_DETAILS_SUCCESS: 'GET_CUSTOMER_DETAILS_SUCCESS',
  GET_CUSTOMER_DETAILS_FAILED: 'GET_CUSTOMER_DETAILS_FAILED',

  GET_CUSTOMER_BOOKINGS: 'GET_CUSTOMER_BOOKINGS',
  GET_CUSTOMER_BOOKINGS_SUCCESS: 'GET_CUSTOMER_BOOKINGS_SUCCESS',
  GET_CUSTOMER_BOOKINGS_FAILED: 'GET_CUSTOMER_BOOKINGS_FAILED',

  EXPORT_CUSTOMER_FILE: 'EXPORT_CUSTOMER_FILE',
  EXPORT_CUSTOMER_FILE_SUCCESS: 'EXPORT_CUSTOMER_FILE_SUCCESS',
  EXPORT_CUSTOMER_FILE_FAILED: 'EXPORT_CUSTOMER_FILE_FAILED',

  BLOCK_CUSTOMER: 'BLOCK_CUSTOMER',
  BLOCK_CUSTOMER_SUCCESS: 'BLOCK_CUSTOMER_SUCCESS',
  BLOCK_CUSTOMER_FAILED: 'BLOCK_CUSTOMER_FAILED',

  UNBLOCK_CUSTOMER: 'UNBLOCK_CUSTOMER',
  UNBLOCK_CUSTOMER_SUCCESS: 'UNBLOCK_CUSTOMER_SUCCESS',
  UNBLOCK_CUSTOMER_FAILED: 'UNBLOCK_CUSTOMER_FAILED',

  UPDATE_CUSTOMER_LEVEL: 'UPDATE_CUSTOMER_LEVEL',
  UPDATE_CUSTOMER_LEVEL_SUCCESS: 'UPDATE_CUSTOMER_LEVEL_SUCCESS',
  UPDATE_CUSTOMER_LEVEL_FAILED: 'UPDATE_CUSTOMER_LEVEL_FAILED',
};

export default CustomerActionTypes;
